import React, { useEffect, useState } from "react";
import AnimatedBookCallButton from "./AnimatedBookCallButton.tsx";

type Props = {
  heroSelector?: string;       // default: '#hero'
  minVisibleRatio?: number;    // show floating when hero visible <= this ratio
};

export default function BookCallFloatController({ heroSelector = "#hero", minVisibleRatio = 0.35 }: Props) {
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const el = document.querySelector(heroSelector);
    if (!el) { setShowFloating(true); return; } // if no hero, float by default

    const observer = new IntersectionObserver(
      ([entry]) => {
        const ratio = entry?.intersectionRatio ?? 0;
        setShowFloating(ratio <= minVisibleRatio);
      },
      { threshold: [0, minVisibleRatio, 1] }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [heroSelector, minVisibleRatio]);

  return showFloating ? <AnimatedBookCallButton variant="floating" /> : null;
}